import { L7Config } from '@zerops/models/project';
import { HashMap } from '@zerops/zef/core';

export interface RemoteLoggingDataPayload {
  certificate?: string;
  syslogConfig: string;
}

export interface VpnPublicKeyPayload {
  publicKey: string;
}

export interface VpnProjectSetting {
  publicKey: string;
  ipv4: {
    network: {
      network: string;
      gateway: string;
    };
    sharedEndpoint: string;
    endpoint: string;
  };
  ipv6: {
    network: {
      network: string;
      gateway: string;
    };
    sharedEndpoint: string;
    endpoint: string;
  };
}

export interface VpnPeerSetting {
  publicKey: string;
  ipv4: {
    network: {
      network: string;
      gateway: string;
    };
    assignedIpAddress: string;
  };
  ipv6: {
    network: {
      network: string;
      gateway: string;
    };
    assignedIpAddress: string;
  };
  setup: string;
  setupWindows: string;
  setupMacOS: string;
  setupLinux: string;
}

export interface VpnSetting {
  project: VpnProjectSetting;
  peer: VpnPeerSetting;
}

export interface VpnSettings {
  project: VpnProjectSetting;
  peers: Array<VpnPeerSetting>;
}

export interface ProjectEnvPayload {
  key: string;
  content: string;
  sensitive?: boolean;
}

export class ProjectBaseState {
  tags: string[];
  vpnSettingsMap: HashMap<VpnSettings>;
  l7ConfigMap: HashMap<L7Config[]>;
  // ephemeral map of project-env id -> revealed (decrypted) value, populated
  // after a successful sudo-authorized /reveal call; cleared on hide / leaving
  revealedEnvContent: Record<string, string>;

  constructor() {
    this.tags = undefined;
    this.vpnSettingsMap = {};
    this.l7ConfigMap = {};
    this.revealedEnvContent = {};
  }
}
